import { render, staticRenderFns } from "./SendWhatsappDialog.vue?vue&type=template&id=8f79293e"
import script from "./SendWhatsappDialog.vue?vue&type=script&lang=js"
export * from "./SendWhatsappDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports